import PropTypes from 'prop-types';
import React from 'react';
import { map } from 'lodash';
import Types from './TariffRatesTypes';
import { FormGroup, ControlLabel, FormControl, Grid, Row, Col } from 'react-bootstrap';

export default class TariffRatesPropsEditor extends React.Component {
    handleNameChange() {
        return (e) => {
            this.props.onChange('name', e.target.value);
        };
    }

    handleFSCChange() {
        return (e) => {
            this.props.onChange('fsc', e.target.value);
        };
    }

    handleTypeChange() {
        return (e) => {
            const type = e.target.value;
            this.props.onChange('type', type);
        };
    }

    validateName(name) {
        const length = (name) ? name.length : 0;
        if (length > 0) {
            return name;
        }
        return 'error';
    }

    render() {
        const tariffRate = this.props.tariffRate || {};
        return (
          <Grid fluid>
            <Row className="show-grid">
              <Col xs={4}>
                <FormGroup>
                  <ControlLabel>Name</ControlLabel>
                  <FormControl
                    type="text"
                    defaultValue={tariffRate.name}
                    onChange={this.handleNameChange()}
                    bsStyle={this.validateName(tariffRate.name)}
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>FSC</ControlLabel>
                  <FormControl
                    type="number"
                    defaultValue={tariffRate.fsc}
                    onChange={this.handleFSCChange()}
                    bsStyle={this.validateName(tariffRate.fsc)}
                  />
                </FormGroup>
              </Col>
              <Col xs={4}>
                <FormGroup>
                  <ControlLabel>Type</ControlLabel>
                  <FormControl
                    componentClass="select"
                    defaultValue={tariffRate.type}
                    onChange={this.handleTypeChange()}
                  >
                    {map(Types, (type, index) => (<option
                      value={type.value}
                      key={`type-${index}`}
                    >{type.name}</option>))}
                  </FormControl>
                </FormGroup>
              </Col>
            </Row>
          </Grid>
        );
    }
}

TariffRatesPropsEditor.propTypes = {
    tariffRate: PropTypes.object,
    onChange: PropTypes.func,
};
